import React from "react";
import { Link } from "react-router-dom";
import { useLang, BLOG_INFO } from "../context/LangContext";
import { useVisibleBlogs, BLOG_COUNT_WORDS } from "../lib/visibleBlogs";
import { API } from "../lib/api";

export default function Footer() {
  const visibleBlogs = useVisibleBlogs();
  const { t, lang } = useLang();
  return (
    <footer className="border-t border-white/10 mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
        <div>
          <div className="flex items-center gap-2">
            <img src="/logo.png" alt="ReiMultiBlog" className="h-8 w-8 rounded-lg object-cover" />
            <span className="font-heading text-lg font-extrabold">Rei<span className="text-primary">MultiBlog</span></span>
          </div>
          <p className="mt-3 text-sm text-muted-foreground max-w-xs">
            {visibleBlogs?.length === 1
              ? t("Um blog independente com guias práticos e experiências em primeira mão.", "One independent blog with practical guides and first-hand experiments.")
              : t(`${(BLOG_COUNT_WORDS[visibleBlogs?.length] || BLOG_COUNT_WORDS[3])[0]} independentes com guias práticos e experiências em primeira mão.`,
                `${(BLOG_COUNT_WORDS[visibleBlogs?.length] || BLOG_COUNT_WORDS[3])[1].split(" ")[0]} independent blogs with practical guides and first-hand experiments.`)}
          </p>
          <p className="mt-3 text-xs text-muted-foreground">MultiBlog.grouprei.com</p>
        </div>
        <div>
          <div className="text-xs font-semibold uppercase tracking-widest text-muted-foreground mb-3">{t("Blogs", "Blogs")}</div>
          <ul className="space-y-2 text-sm">
            {(visibleBlogs || []).map((b) => (
              <li key={b}>
                <Link to={`/blog/${b}`} className="text-muted-foreground hover:text-foreground transition-colors">
                  {lang === "pt" ? BLOG_INFO[b].pt : BLOG_INFO[b].en}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/sobre" data-testid="footer-about" className="text-muted-foreground hover:text-foreground transition-colors">{t("Sobre", "About")}</Link>
            </li>
          </ul>
        </div>
        <div>
          <div className="text-xs font-semibold uppercase tracking-widest text-muted-foreground mb-3">{t("Institucional", "About")}</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/autor" data-testid="footer-author" className="text-muted-foreground hover:text-foreground transition-colors">{t("Sobre o autor", "About the author")}</Link></li>
            <li><Link to="/contacto" data-testid="footer-contact" className="text-muted-foreground hover:text-foreground transition-colors">{t("Contacto", "Contact")}</Link></li>
            <li><Link to="/sugestoes" data-testid="footer-suggestions" className="text-muted-foreground hover:text-foreground transition-colors">{t("Sugestões", "Suggestions")}</Link></li>
            <li><Link to="/contribuir" data-testid="footer-contribute" className="text-muted-foreground hover:text-foreground transition-colors">{t("Quero contribuir", "Contribute")}</Link></li>
            <li><Link to="/privacidade" data-testid="footer-privacy" className="text-muted-foreground hover:text-foreground transition-colors">{t("Privacidade", "Privacy")}</Link></li>
            <li><Link to="/termos" data-testid="footer-terms" className="text-muted-foreground hover:text-foreground transition-colors">{t("Termos", "Terms")}</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs font-semibold uppercase tracking-widest text-muted-foreground mb-3">{t("Feeds", "Feeds")}</div>
          <ul className="space-y-2 text-sm">
            <li><a href={`${API}/rss.xml`} target="_blank" rel="noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">RSS</a></li>
            <li><a href={`${API}/sitemap.xml`} target="_blank" rel="noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Sitemap</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs text-muted-foreground">
        © {new Date().getFullYear()} ReiMultiBlog · GroupRei
      </div>
    </footer>
  );
}
